export enum InviteModalMode {
  Invite = "Invite",
  TrialExtension = "TrialExtension",
}
